/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Businessnotfounderror3Inputs */

const en_businessnotfounderror3 = /** @type {(inputs: Businessnotfounderror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Business not found.`)
};

const de_businessnotfounderror3 = /** @type {(inputs: Businessnotfounderror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unternehmen wurde nicht gefunden.`)
};

/**
* | output |
* | --- |
* | "Business not found." |
*
* @param {Businessnotfounderror3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const businessnotfounderror3 = /** @type {((inputs?: Businessnotfounderror3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Businessnotfounderror3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_businessnotfounderror3(inputs)
	return de_businessnotfounderror3(inputs)
});
export { businessnotfounderror3 as "businessNotFoundError" }